import { lazy } from 'react';
import AccessDenied from './AccessDenied';
import { Login } from './Auth';

const LandingPage = lazy(() => import('./LandingPage'));

export { AccessDenied, Login, LandingPage };
